import { defineMessages } from 'react-intl';

export default defineMessages({
  title: {
    id: 'reports.generalPanelTRI.avgRankingTable.title',
    defaultMessage: 'Comparison of average grade by application',
  },
  generateSpreadSheet: {
    id: 'reports.generalPanelTRI.avgRankingTable.generateSpreadSheet',
    defaultMessage: 'Generate SpreadSheet',
  },
  studentName: {
    id: 'reports.generalPanelTRI.avgRankingTable.studentName',
    defaultMessage: 'Student name',
  },
  filename: {
    id: 'reports.generalPanelTRI.avgRankingTable.filename',
    defaultMessage: 'averageGrade',
  },
  tabname: {
    id: 'reports.generalPanelTRI.avgRankingTable.tabname',
    defaultMessage: 'Average Grade',
  },
  avg: {
    id: 'reports.generalPanelTRI.avgRankingTable.avg',
    defaultMessage: 'Average',
  },
  objective: {
    id: 'reports.generalPanelTRI.avgRankingTable.objective',
    defaultMessage: 'Objective',
  },
  writing: {
    id: 'reports.generalPanelTRI.avgRankingTable.writing',
    defaultMessage: 'Writing',
  },
  avgObj: {
    id: 'reports.generalPanelTRI.avgRankingTable.avgObj',
    defaultMessage: 'Objective Average',
  },
  class: {
    id: 'reports.generalPanelTRI.avgRankingTable.class',
    defaultMessage: 'Class',
  },
});
